// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ModelDate } from "./ModelDate";
import {
  ModelDateFromJSON,
  ModelDateFromJSONTyped,
  ModelDateToJSON,
  ModelDateToJSONTyped,
} from "./ModelDate";

/**
 *
 * @export
 * @interface Citation
 */
export interface Citation {
  /**
   * Naam van de dataset of dataset serie.
   */
  title: string;
  /**
   *
   */
  date: Array<ModelDate>;
  /**
   * Filter by project
   */
  identifier?: string | null;
  /**
   *
   */
  identifierNamespace?: string | null;
}

/**
 * Check if a given object implements the Citation interface.
 */
export function instanceOfCitation(value: object): value is Citation {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("date" in value) || value["date"] === undefined) return false;
  return true;
}

export function CitationFromJSON(json: any): Citation {
  return CitationFromJSONTyped(json, false);
}

export function CitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Citation {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    date: (json["date"] as Array<any>).map(ModelDateFromJSON),
    identifier:
      json["identifier"] === undefined
        ? undefined
        : json["identifier"] === null
        ? null
        : json["identifier"],
    identifierNamespace:
      json["identifier_namespace"] === undefined
        ? undefined
        : json["identifier_namespace"] === null
        ? null
        : json["identifier_namespace"],
  };
}

export function CitationToJSON(json: any): Citation {
  return CitationToJSONTyped(json, false);
}

export function CitationToJSONTyped(
  value?: Citation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    date: (value["date"] as Array<any>).map(ModelDateToJSON),
    identifier: value["identifier"],
    identifier_namespace: value["identifierNamespace"],
  };
}
